import { ref } from 'vue'
import type { Ref } from 'vue'
import type { DashboardStats } from '@/types/dashboard'
import { fetchDashboardStats as apiFetchDashboardStats } from '@/api/dashboard'
import { useAuth } from '@/composables/useAuth'

const { currentOrganisation } = useAuth()

const dashboardStats = ref<DashboardStats | null>(null)
const statsLoading = ref(false)
const statsError = ref<string | null>(null)

async function fetchDashboardStats(): Promise<void> {
  if (!currentOrganisation.value) return
  statsLoading.value = true
  statsError.value = null
  try {
    dashboardStats.value = await apiFetchDashboardStats(currentOrganisation.value.id)
  } catch {
    statsError.value = 'dashboard.organizer.stats_error'
  } finally {
    statsLoading.value = false
  }
}

export function useDashboardStats(): {
  dashboardStats: Ref<DashboardStats | null>
  statsLoading: Ref<boolean>
  statsError: Ref<string | null>
  fetchDashboardStats: () => Promise<void>
} {
  return {
    dashboardStats,
    statsLoading,
    statsError,
    fetchDashboardStats,
  }
}
